<template>
  <header class="background-dark-gray">

    <div style="flex: 2;">
      <router-link to="/" tag="div">
        <div class="logo">
          <span class="logo-image">
            <QCRMlogo />
          </span>
          <span class="logo-text">QBotBuilder</span>
        </div>
      </router-link>
    </div>

    <div style="flex: 4;">
      <BasicInput placeholder="Search..." v-model="searchBot" @input="searchBotInput" class="wide search-field" v-if="!isBotView" />
    </div>


    <div style="flex: 2;" class="back-button-container">
      
      <div v-if="isBotView">
        <router-link to="/">
          <BotActionButton class="gray back-button">Back to List</BotActionButton>
        </router-link>
      </div>

      <div v-if="!isBotView">
        <BotActionButton class="blue create-bot" @click="openCreateBotPopup()">Create Bot</BotActionButton>
      </div>
      
    </div>

  </header>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import QCRMlogo from "@/components/icons/QCRMlogo"
import BotActionButton from "@/components/buttons/BotActionButton"
import BasicInput from '@/components/inputs/BasicInput'

export default {
  data: () => {
    return {
      searchBot: ""
    } 
  },
  computed: {
    ...mapGetters(["getUser"]),
    isBotView() {
      return this.$route.path.match("/bot");
    }
  },
  methods: {
    searchBotInput(value) {
      this.$root.$emit('searchBots', value)
    },
    openCreateBotPopup() {
      this.$root.$emit('openCreateBotPopup')
    }
  },
  components: { QCRMlogo, BotActionButton, BasicInput}
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 60px;
  padding: 6px 1.25em;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #4c4c4c;

  position: relative;
  z-index: 100;

  .search-field {
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 2px;
    border: 1px solid rgba($color: #999999, $alpha: 0.7);
    transition: all .3s cubic-bezier(.25,.8,.25,1);
    
    &:hover {
      border-color: rgba($color: #999999, $alpha: 1);
    }
    &:focus {
      border-color: #FBB442;
    }
  }

  .back-button-container {
    
    .back-button {
      margin: 0;
      float: right;
    }
  }

  .create-bot {
    margin: 0;
    float: right;
  }

}
.background-dark-gray {
  background-color: #2b2b2b;
}
.logo {
  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;

  svg {
    width: 40px;
  }
  .logo-image {
    height: 40px;
    width: 40px;
    margin-right: 0.75em;
  }
  .logo-text {
    color: #fff;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 400;
    text-decoration: none;
  }
}
</style>